import { useState } from 'react';
import { Text } from 'mondrian-react';
import { Link } from 'react-router-dom';

function Description({value}) {
  
  const [isReadMore, setReadMore] = useState(false);
  
  const descriptionLimit = 380; // limit of result description.

  const limitDescription = (description) => {
    let result = description.split('').splice(0, descriptionLimit).join('');
    let etc = description.split('').splice(descriptionLimit).join('');
    return [
      !isReadMore ? `${result}... ` : `${result}${etc} `,
      <Link inline onClick={()=>setReadMore(!isReadMore)}>Ler { !isReadMore ? "mais" : "menos" }</Link>
    ]
  }

  return (
    <Text body>{limitDescription(value)}</Text>
  );
}

export default Description;
